import useAsyncFn from 'react-use/lib/useAsyncFn';

import { shortenUrl } from '../utils/share';
import { useWebsite } from './useWebsite';

export const useShortUrl = (payload: Parameters<typeof shortenUrl>[0]) => {
  // fullBasepathUrl = host canonique + basePath du tenant (ex. `/forums` de
  // beaute-test). La branche `slug` de `shortenUrl` repart de là, sinon elle perd
  // ce préfixe → 404. Cf. basepath-prefixed-yakli-links_P1 (contrat basePath B8_02).
  const { fullBasepathUrl } = useWebsite();

  return useAsyncFn<() => Promise<string>>(
    () => shortenUrl(payload, fullBasepathUrl).then(data => data.short_url),
    [payload, fullBasepathUrl],
  );
};
